import React from "react";
import { inject, observer } from 'mobx-react';

const BiometricLock = inject("rootstore", "langstore")(observer(({ rootstore, langstore, onRetry, onBypass, loading }) => {
  const userName = rootstore.userInfo?.name || '';

  return (
    <div className="ts_view_content">
      <div className="row justify-content-center">
        <div className="col-12 mb-5 text-center">

          {userName && (
            <p className="title3 mb1">
              {langstore.t("biometric_welcome_back", "Bentornato")},
            </p>
          )}
          <h1 className="title1 mb6 t300">
            {userName || langstore.t("biometric_lock_title", "Sessione bloccata")}
          </h1>

          <div className="mb5" style={{ fontSize: '3rem', lineHeight: 1 }}>
            <i className="fas fa-fingerprint title1" />
          </div>

          {loading ? (
            <p className="title3 mb5">
              {langstore.t("biometric_verifying", "Verifica in corso…")}
            </p>
          ) : (
            <>
              <p className="title3 mb5">
                {langstore.t("biometric_cancelled", "Verifica non completata")}
              </p>
              <button
                className="ts_button1 d-block w-100 mb5"
                onClick={onRetry}
              >
                {langstore.t("biometric_retry", "Riprova")}
              </button>
              <p
                className="ts_link1"
                style={{ cursor: 'pointer' }}
                onClick={onBypass}
              >
                {langstore.t("biometric_use_credentials", "Usa le credenziali")}
              </p>
            </>
          )}

        </div>
      </div>
    </div>
  );
}));

export default BiometricLock;
